/**
 * Data-quality validators mirrored from /api/backend/data_quality.py.
 * Used inline by forms (Inbox composer, Leads new-lead dialog, ServiceRequest form).
 *
 * All patterns are also fetched at app boot from GET /api/data-quality/rules and
 * cached — the client-side regex here is the fast path for form UX.
 */
const DR_PHONE_PREFIXES = ["809", "829", "849"];

export const RULES = {
  cedula: {
    digits: 11,
    pattern: /^\d{11}$/,
    example: "40212345678",
    hint: "11 dígitos (ej: 402-1234567-8)",
  },
  rnc: {
    digits: [9, 11],
    pattern: /^\d{9}$|^\d{11}$/,
    example: "131123456",
    hint: "9 u 11 dígitos",
  },
  pasaporte: {
    min: 6,
    max: 12,
    pattern: /^[A-Za-z0-9]{6,12}$/,
    example: "AB123456",
    hint: "6 a 12 caracteres alfanuméricos",
  },
  vin: {
    length: 17,
    pattern: /^[A-HJ-NPR-Z0-9]{17}$/,
    example: "1HGCM82633A123456",
    hint: "17 caracteres — sin las letras I, O ni Q",
  },
  phone: {
    digits: 10,
    prefixes: DR_PHONE_PREFIXES,
    pattern: /^(809|829|849)\d{7}$/,
    example: "8095551234",
    hint: "10 dígitos con prefijo 809/829/849",
  },
  email: {
    pattern: /^[^@\s]+@[^@\s]+\.[^@\s]+$/,
    example: "cliente@ejemplo.com",
    hint: "formato usuario@dominio.com",
  },
};

/** Normalize by stripping non-relevant characters. Returns { normalized, valid, error, hint }. */
export function validateField(field, raw) {
  const rule = RULES[field];
  if (!rule) return { normalized: raw, valid: true };
  if (!raw || String(raw).trim() === "") {
    return { normalized: "", valid: false, error: "Requerido", hint: rule.hint };
  }

  let normalized = String(raw).trim();

  if (field === "cedula" || field === "rnc" || field === "phone") {
    normalized = normalized.replace(/\D+/g, "");
    if (field === "phone" && normalized.length === 11 && normalized.startsWith("1")) {
      normalized = normalized.slice(1);
    }
  }
  if (field === "vin" || field === "pasaporte") {
    normalized = normalized.replace(/[\s-]+/g, "").toUpperCase();
  }
  if (field === "email") {
    normalized = normalized.toLowerCase();
  }

  const valid = rule.pattern.test(normalized);
  if (!valid) {
    let msg;
    if (field === "cedula") msg = `Cédula debe tener 11 dígitos (recibí ${normalized.length}).`;
    else if (field === "rnc") msg = `RNC debe tener 9 u 11 dígitos (recibí ${normalized.length}).`;
    else if (field === "pasaporte") msg = "Pasaporte: 6–12 caracteres alfanuméricos.";
    else if (field === "vin") msg = `VIN debe tener 17 caracteres alfanuméricos, sin I, O ni Q (recibí ${normalized.length}).`;
    else if (field === "phone") {
      if (normalized.length !== 10) msg = `Teléfono debe tener 10 dígitos (recibí ${normalized.length}).`;
      else msg = `Prefijo debe ser 809/829/849 (recibí ${normalized.slice(0, 3)}).`;
    } else if (field === "email") msg = "Email inválido.";
    else msg = "Formato inválido.";
    return { normalized, valid: false, error: msg, hint: rule.hint };
  }
  return { normalized, valid: true, hint: rule.hint };
}
